module.exports = __webpack_public_path__ + "img/2-4.89376e55.svg";